import React, { useEffect, useState } from 'react';
import { themeGreen } from '../../theme';
import Layout from '../../components/Layout/Layout';
import { Fade, Box, Container, makeStyles, Typography, Button } from '@material-ui/core';
import ReviewCard from '../../components/ReviewCard/ReviewCard';

const useStyles = makeStyles(theme => ({
    MainWrapper: { margin: 'auto', height: '100%', marginTop: '80px'},
}))


function Success(props) {
    const [loading, setLoading] = useState(false)
    const classes = useStyles(themeGreen);
    const [reviewData, setReviewData] = useState({
        name: null,
        surname: null,
        username: null,
        pComment: null,
        nComment: null,
        date: null,
        rating: 0
    })
    
    const [param_r2, setParamR2] = React.useState(props.match.params['rubro2']);
    const [param_mod, setParamMod] = React.useState(props.match.params['model']);
    // useEffect(() => {
    //     fetch('https://www.agroads.com.ar/reviews/api/es.asp?action=get&pKey=777CF658-1807-4C22-9D52-1E451A7B4606')
    //         .then(res => res.json())
    //         .then(data => {
    //             console.log("data", data)
    //             setReviewData({ ...reviewData, name: data.reviewer_name, username: data.reviewer_username, surname: data.reviewer_surname, pComment: data.positive, nComment: data.negative, date: data.date_created, rating: data.rating })
    //         })
    //         .catch(console.log)
    // }, [])

    return (
        <Layout loading={loading}>
            <Fade in={true} timeout={1000}>
                <Container maxWidth="lg">
                    <Box display="flex" flexDirection='column' justifyContent='center' alignItems="flexStart" className={classes.MainWrapper}>                            
                        <Typography variant='h3'>¡Gracias por tu colaboración!</Typography>                                                        
                        <Box mt={2}>
                            <Typography>Miles de personas confían en reseñas como la tuya para decidir qué comprar.</Typography>                             
                        </Box>
                        <Box mt={5}>                            
                            <Button color="primary" variant='outlined' href={`/reviews/r/${param_r2}/modelo/${param_mod}/`}>Ver calificaciones</Button>
                        </Box>
                    </Box>
                </Container>
            </Fade>
        </Layout>        
    )
}   

export default Success;